/**
 * @ignore
 * @classdesc 路径规划接口
 * @alias G.service.IRouteService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 */
class IRouteService {
    constructor(opts) {}

    /**
     * 驾车
     * @param {Object} opts 
     * @param {Number[]} opts.origin 起点
     * @param {Number[]} opts.destination 终点
     * @param {String} opts.spatialReference 起终点坐标系
     * @param {Integer} opts.strategy
     * @param {Object} opts.custom 适配不同服务的定制参数
     * @returns {Object}
     */
    driving(opts) {}

    /**
     * 公交
     * @param {Object} opts 
     * @param {Number[]} opts.origin 起点
     * @param {Number[]} opts.destination 终点
     * @param {String} opts.spatialReference 起终点坐标系
     * @param {Object} opts.custom 适配不同服务的定制参数
     * @returns {Object}
     */
    transit(opts) {}

    /**
     * 步行
     * @param {Object} opts 
     * @param {Number[]} opts.origin 起点
     * @param {Number[]} opts.destination 终点
     * @param {String} opts.spatialReference 起终点坐标系
     * @param {Object} opts.custom 适配不同服务的定制参数
     * @returns {Object}
     */
    walking(opts) {}

    /**
     * 骑行
     * @param {Object} opts 
     * @param {Number[]} opts.origin 起点
     * @param {Number[]} opts.destination 终点
     * @param {String} opts.spatialReference 起终点坐标系
     * @param {Object} opts.custom 适配不同服务的定制参数
     * @returns {Object}
     */
    riding(opts) {}
}
module.exports = IRouteService;